import React from "react";
import Api from "../../../../services/ServiceApi";
import { Popover } from "antd";
import { uuidv4 } from "../../../../components/utility/genuuid";
import { isMobile } from "react-device-detect";
export default function renderButton({
  renderBtn,
  btnMiddleware,
  item,
  disable,
}) {
  function genButton() {
    if (renderBtn.visible === false) {
      return null;
    } else {
      if (renderBtn.html_tag === "button") {
        if (renderBtn.type === "FAwithText") {
          return (
            <button
              key={uuidv4()}
              type="button"
              className={`${renderBtn.css}`}
              onClick={() => btnMiddleware(item)}
              disabled={disable}
            >
              {renderBtn.icon_align === "left" ? (
                <>
                  <i className={renderBtn.font_awasome}></i>
                  <span>{renderBtn.text}</span>
                </>
              ) : (
                <>
                  <span>{renderBtn.text}</span>
                  <i className={renderBtn.font_awasome}></i>
                </>
              )}
            </button>
          );
        } else if (renderBtn.type === "FA") {
          return (
            <button
              key={uuidv4()}
              type="button"
              className={`${renderBtn.css}`}
              onClick={() => btnMiddleware(item)}
              disabled={disable}
            >
              <i className={renderBtn.font_awasome}></i>
            </button>
          );
        } else if (renderBtn.type === "ImagewithText") {
          return (
            <button
              key={uuidv4()}
              type="button"
              className={`${renderBtn.css}`}
              onClick={() => btnMiddleware(item)}
              disabled={disable}
            >
              {renderBtn.icon_align === "left" ? (
                <>
                  <img
                    src={Api.absoluteUrl(`${renderBtn.image_path}`)}
                    alt={`${renderBtn.image_path}`}
                  ></img>
                  <span>{renderBtn.text}</span>
                </>
              ) : (
                <>
                  <span>{renderBtn.text}</span>
                  <img
                    src={Api.absoluteUrl(`${renderBtn.image_path}`)}
                    alt={`${renderBtn.image_path}`}
                  ></img>
                </>
              )}
            </button>
          );
        } else if (renderBtn.type === "Image") {
          return (
            <button
              key={uuidv4()}
              type="button"
              className={`${renderBtn.css}`}
              onClick={() => btnMiddleware(item)}
              disabled={disable}
            >
              <img
                src={Api.absoluteUrl(`${renderBtn.image_path}`)}
                alt={`${renderBtn.image_path}`}
              ></img>
            </button>
          );
        } else if (renderBtn.type === "Text") {
          return (
            <button
              key={uuidv4()}
              type="button"
              className={renderBtn.css}
              onClick={() => btnMiddleware(item)}
              disabled={disable}
            >
              <span>{renderBtn.text}</span>
            </button>
          );
        } else {
          return (
            <button
              key={uuidv4()}
              type="button"
              className={renderBtn.css}
              onClick={() => btnMiddleware(item)}
              disabled={disable}
            >
              <span>{renderBtn.text}</span>
            </button>
          );
        }
      } else if (renderBtn.html_tag === "label") {
        if (renderBtn.type === "FAwithText") {
          return (
            <span key={uuidv4()} className={`${renderBtn.css}`}>
              {renderBtn.icon_align === "left" ? (
                <>
                  <i className={renderBtn.font_awasome}></i>
                  <span>{renderBtn.text}</span>
                </>
              ) : (
                <>
                  <span>{renderBtn.text}</span>
                  <i className={renderBtn.font_awasome}></i>
                </>
              )}
            </span>
          );
        } else if (renderBtn.type === "FA") {
          return (
            <span key={uuidv4()} className={`${renderBtn.css}`}>
              <i className={renderBtn.font_awasome}></i>
            </span>
          );
        } else if (renderBtn.type === "ImagewithText") {
          return (
            <span key={uuidv4()} className={`${renderBtn.css}`}>
              {renderBtn.icon_align === "left" ? (
                <>
                  <img
                    src={Api.absoluteUrl(`${renderBtn.image_path}`)}
                    alt={`${renderBtn.image_path}`}
                  ></img>
                  <span>{renderBtn.text}</span>
                </>
              ) : (
                <>
                  <span>{renderBtn.text}</span>
                  <img
                    src={Api.absoluteUrl(`${renderBtn.image_path}`)}
                    alt={`${renderBtn.image_path}`}
                  ></img>
                </>
              )}
            </span>
          );
        } else if (renderBtn.type === "Image") {
          return (
            <span key={uuidv4()} className={`${renderBtn.css}`}>
              <img
                src={Api.absoluteUrl(`${renderBtn.image_path}`)}
                alt={`${renderBtn.image_path}`}
              ></img>
            </span>
          );
        } else if (renderBtn.type === "Text") {
          return (
            <span key={uuidv4()} className={`${renderBtn.css}`}>
              <span>{renderBtn.text}</span>
            </span>
          );
        } else {
          return (
            <span key={uuidv4()} className={`${renderBtn.css}`}>
              <span>{renderBtn.text}</span>
            </span>
          );
        }
      }
    }
  }
  return (
    <>
      {isMobile ? (
        genButton()
      ) : renderBtn.popover?.enable ? (
        <Popover
          content={renderBtn.popover?.content}
          title={renderBtn.popover?.title}
        >
          {genButton()}
        </Popover>
      ) : (
        genButton()
      )}
    </>
  );
}
